import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import TicketStreamCard from './TicketStreamCard'

function getCallerFromOpenTicketCmd(cmd) {
    const caller = cmd.ticket.callerz

    switch(caller.callerType) {
        case 'ReferencedContactCaller': return {
            name: caller.uid.name,
            medium: caller.uid.contacts
        }
        case 'HumanCaller': return {
            name: caller.namez,
            medium: caller.medium && [caller.medium] || []
        }
    }
}

class OpenTicketStreamCardLayout extends Component {
    static propTypes = {
    }

    render() {
        const {dispatch, cmd, onSubmit, ...others} = this.props

        return (cmd && cmd.locationRef && cmd.locationRef.patrimonyUid) != null && (
            <TicketStreamCard
                patrimony={cmd.locationRef.patrimonyUid}
                callPurpose={cmd.ticket && cmd.ticket.openingTicketPurpose && cmd.ticket.openingTicketPurpose.label}
                onSubmit={(e, a, t) => onSubmit(e, a, getCallerFromOpenTicketCmd(cmd), t)} />
        )
    }
}

OpenTicketStreamCardLayout = connect((state) => ({
    cmd: state.ticket.openTicketCmd
}))(OpenTicketStreamCardLayout)

export default OpenTicketStreamCardLayout


// WEBPACK FOOTER //
// ./lib/ticket/components/OpenTicketStreamCardLayout.js